import { render } from "./UiInput.vue?vue&type=template&id=66270c34&scoped=true&lang=pug"
import script from "./UiInput.vue?vue&type=script&lang=js"
export * from "./UiInput.vue?vue&type=script&lang=js"

import "./UiInput.vue?vue&type=style&index=0&id=66270c34&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66270c34"]])

export default __exports__